// extracted by mini-css-extract-plugin
export default {"imageWrapper":"AR-z","hovered":"BR-z","hoverImage":"CR-z","mainImage":"DR-z","imageNoBackground":"ER-z","fullSizeImage":"FR-z"};